/**
 * Plain immutable class, deliberately NOT extending `AbstractFilterView`: that base class carries
 * `page`/`rows`/`setPageAndRows`/`queryParams` — the tooling of a *server* filter, none of which this
 * screen uses (every filter here is client-side, D-16). Extending it "because other filter Views do"
 * would introduce a `queryParams` nobody calls, and mislead the next reader into thinking the list is
 * filtered server-side.
 */
class StaffMemberFilterView {
	readonly search: string;
	readonly jobFunction: string | null;
	readonly facilityId: number | null;

	constructor(search: string, jobFunction: string | null, facilityId: number | null) {
		this.search = search;
		this.jobFunction = jobFunction;
		this.facilityId = facilityId;

		Object.freeze(this);
	}

	static createDefault(): StaffMemberFilterView {
		return new StaffMemberFilterView('', null, null);
	}

	/** Number of criteria that narrow the results; sorting never counts. */
	get activeFilterCount(): number {
		return [this.search.length > 0, this.jobFunction !== null, this.facilityId !== null].filter(Boolean)
			.length;
	}

	setSearch(search: string): StaffMemberFilterView {
		return new StaffMemberFilterView(search, this.jobFunction, this.facilityId);
	}

	setJobFunction(jobFunction: string | null): StaffMemberFilterView {
		return new StaffMemberFilterView(this.search, jobFunction, this.facilityId);
	}

	setFacilityId(facilityId: number | null): StaffMemberFilterView {
		return new StaffMemberFilterView(this.search, this.jobFunction, facilityId);
	}

	hasActiveFilters(): boolean {
		return this.activeFilterCount > 0;
	}
}

export default StaffMemberFilterView;
